import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

interface Data extends SelfServiceAPI.CreateDateAmendment.Request {
  bookingId: string;
}

const createDateAmendment = async (
  { bookingId, checkIn, checkOut }: Data,
  options: Options = {},
): Promise<SelfServiceAPI.CreateDateAmendment.Response> => {
  try {
    const { data } = await api.post(`/bookings/${bookingId}/date-amendment`, { checkIn, checkOut });
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/date-amendment`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default createDateAmendment;
